import { Stack, LoadingButton } from "@altimateai/lego";
import { useEffect } from "react";
import { ApiHelper, useMutation } from "../api/index";
import { CoachAiResponse, TaskLabels } from "./types";
import { CoachFormValues, coachFormSchema } from "./AddLearningForm";
import { Button, Textarea } from "@altimateai/lego";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const CoachFormInput = ({
  taskLabel,
  onSuccess,
  onCancel,
}: {
  taskLabel: keyof typeof TaskLabels;
  onSuccess: (data: CoachAiResponse) => void;
  onCancel: () => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm<CoachFormValues>({
    resolver: zodResolver(coachFormSchema),
    defaultValues: {
      content: "",
    },
  });

  const { mutate, error, loading } = useMutation<CoachFormValues, CoachAiResponse>({
    queryFn: async (values: CoachFormValues) => {
      return await ApiHelper.post<CoachAiResponse>(`coach/training`, {
        ...values,
        taskLabel,
      });
    },
    onSuccess: (data: CoachAiResponse) => {
      onSuccess(data);
    },
  });

  useEffect(() => {
    if (error?.message) {
      setError("content", { message: error.message });
    }
  }, [error, setError]);

  const onSubmit = (values: CoachFormValues) => {
    mutate(values);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="al-space-y-2">
        <Textarea {...register("content")} className={errors.content ? "al-border-red-500" : ""} />
        {errors.content && (
          <p className="al-text-sm al-font-medium al-text-destructive">{errors.content.message}</p>
        )}
      </div>
      <Stack justify="end" className="mt-2">
        <Button variant="outline" onClick={onCancel} type="button">
          Cancel
        </Button>
        <LoadingButton loading={loading || isSubmitting} type="submit">
          Coach AI
        </LoadingButton>
      </Stack>
    </form>
  );
};

export default CoachFormInput;
